import MainRecomendador from "../components/recomendador/MainRecomendador";

function Recomendador() {
  return <MainRecomendador />;
}

export default Recomendador;
